import React from 'react';
import { Box, Typography, Button, IconButton } from '@mui/joy';
import { Clock as Schedule, CreditCard, X as Close } from '@phosphor-icons/react';

interface TrialNotificationProps {
  daysRemaining: number;
  tierName: string;
  onDismiss?: () => void;
  onSubscribe?: () => void;
}

export const TrialNotification: React.FC<TrialNotificationProps> = ({
  daysRemaining,
  tierName,
  onDismiss,
  onSubscribe,
}) => {
  const getMessage = () => {
    if (daysRemaining === 1) {
      return `Your ${tierName} trial expires tomorrow! Subscribe now to keep your data.`;
    } else if (daysRemaining === 0) {
      return `Your ${tierName} trial has expired! Subscribe now to regain access.`;
    } else {
      return `Your ${tierName} trial expires in ${daysRemaining} days. Subscribe to continue.`;
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 3,
        py: 2,
        background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)',
        color: 'white',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Schedule size={19} />
        <Typography level="body-md" sx={{ fontWeight: 500 }}>
          {getMessage()}
        </Typography>
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Button
          size="sm"
          variant="solid"
          color="neutral"
          startDecorator={<CreditCard />}
          onClick={onSubscribe}
          sx={{
            bgcolor: 'white',
            color: 'var(--brand-text, #7013f5)',
            fontWeight: 'bold',
            '&:hover': {
              bgcolor: 'grey.100',
            },
          }}
        >
          Subscribe today!
        </Button>
        
        {onDismiss && (
          <IconButton
            size="sm"
            variant="plain"
            onClick={onDismiss}
            sx={{
              color: 'white',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <Close />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};